import React, { FC, useContext, useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router";
import { hasAnySubscription, isAuthenticated } from "../utils/Helper";
import { Routes } from "../constants/RouteConstants";
import authContext from "../context/authContext";
import PageLoader from "../components/layouts/PageLoader";
import { USER_ROLE_TYPES } from "../constants/Constants";

interface PropType {
  component: React.FC;
}

const PrivateRoute: FC<PropType> = ({ component: Component }) => {
  const { pathname } = useLocation();
  const profileData: any = useContext(authContext);
  console.log("profileData", profileData);

  const [showLoader, setShowLoader] = useState(true);
  const freeRoutes = [
    Routes.Dashboard,
    Routes.Profile,
    Routes.UpdateProfile,
    Routes.Subscription,
    Routes?.ChangePassword,
    Routes?.NotificationSettings,
    Routes?.Notifications,
    Routes?.OpportunityCost,
    Routes?.Payment,
    Routes?.Reports,
  ];

  useEffect(() => {
    if (!profileData?.loading) {
      setShowLoader(false);
    }
  }, [profileData?.loading]);

  if (showLoader) {
    return <PageLoader />;
  }

  if (isAuthenticated()) {
    const hasPendingInvite = profileData?.invitation_accept_pending || profileData?.data?.invitation_accept_pending;
    if (hasPendingInvite) {
      return <Navigate to={Routes?.HouseholdInvitation} />;
    }
    if (profileData?.data?.is_profile_setup === 0) {
      return (
        <>
          <Component />
          <Navigate to={Routes?.ManageProfile} />
        </>
      );
    } else if (profileData?.data?.role_type === USER_ROLE_TYPES?.IS_FOR_FIRST_TIME) {
      if (!profileData?.data?.is_invitee && !hasAnySubscription(profileData?.data) && !freeRoutes?.includes(pathname)) {
        return (
          <>
            <Component />
            <Navigate to={Routes?.Subscription} />
          </>
        );
      }
    }
    return <Component />;
  } else {
    return <Navigate to={Routes?.Login} />;
  }
};

export default PrivateRoute;

// import React, { FC, useContext } from 'react';
// import { Navigate } from 'react-router';
// import { isAuthenticated } from '../utils/Helper';
// import { Routes } from '../constants/RouteConstants';
// import authContext from '../context/authContext';
// import PageLoader from '../components/layouts/PageLoader';
// import { USER_ROLE_TYPES } from '../constants/Constants';

// interface PropType {
//     component: React.FC;
// }

// const PrivateRoute: FC<PropType> = ({ component: Component }) => {
//     const profileData: any = useContext(authContext);
//     if (profileData?.loading) {
//         return <PageLoader />
//     } else if (isAuthenticated()) {
//         if (profileData?.data?.is_profile_setup === 0) {
//             return (
//                 <>
//                     <Component />
//                     <Navigate to={Routes?.ManageProfile} />
//                 </>
//             )
//         } else if (profileData?.data?.role_type === USER_ROLE_TYPES?.GROUP_ADMIN) {
//             if (!profileData?.data?.is_premium) {
//                 return (
//                     <>
//                         <Component />
//                         <Navigate to={Routes?.Subscription} />
//                     </>
//                 )
//             }
//         }
//         return <Component />;
//     }
//     else {
//         return <Navigate to={Routes?.Login} />;
//     }
// };

// export default PrivateRoute;
